import { ComplexContentModel } from '@eag/sales-app-base/build/app/core/rest-api/model/complex-content-model';
import { classNames } from 'primereact/utils';
import { parseIdFromYoutubeVideoUrl } from 'utils/urlUtils';

interface Props {
	content: ComplexContentModel;
	className: string;
}

function ArticleWithVideoComponent(props: Props) {
	const { content, className } = props;
	const videoId = content.children?.[0].mediaUrl ? parseIdFromYoutubeVideoUrl(content.children[0].mediaUrl) : undefined;

	return (
		<section className={classNames('login-page-content', className)}>
			<div className={'content-block col-12 col@md-9'}>
				<h6>{content.header}</h6>
				{content.body && <div dangerouslySetInnerHTML={{ __html: content.body }} />}
			</div>
			{videoId && (
				<div className="video-block col-12 col@md-3">
					<div className="video-wrapper">
						<iframe
							style={{ border: 0 }}
							src={`//www.youtube.com/embed/${videoId}?showinfo=0&amp;rel=0&amp;modestbranding=1&amp;autohide=1&amp;mute=0&amp;showinfo=0&amp;controls=1&amp;loop=1&amp;autoplay=0`}
							title="YouTube video player"
							allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
							allowFullScreen></iframe>
					</div>
				</div>
			)}
		</section>
	);
}

export default ArticleWithVideoComponent;
